import { PushArticlesBlogB2b } from '@components/push-articles-blog-b2b/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const pushArticlesBlogB2bMock: Block<PushArticlesBlogB2b> = {
  type: 'push-articles-blog-b2b',
  data: {
    title: "L'actu de nos franchisés",
    articles: [
      {
        title: 'Denis ouvre son 2ème magasin à Rochefort !',
        url: '/mock-blog-article/denis-2eme-magasin',
        image: imageMock,
        description: `Après le succès de son magasin à Saintes, c'est à Rochefort que Denis décide d'implanter le nouveau point d'expansion de son empire. Longue vie à Denis !`,
      },
      {
        title: 'À Montbéliard, 3 nouveaux cas de vol de tarte à la framboise',
        url: '/mock-blog-article/montbeliard-framboise',
        image: imageMock,
        description: `Rien ne va plus dans chez Socoo'c Montbéliard, modeste village accueillant la saucisse du même nom. Les cas de disparition de tartes se multiplient, et on n'a toujours pas retrouvé le coupable. Enquête à suivre...`,
      },
      {
        title: "Drake visite Socoo'c Limoges",
        url: '/mock-blog-article/limoges-drake',
        image: imageMock,
        description: `Joli coup de pub pour Socoo'c Limoges, qui a eu mardi dernier la chance incroyable de recevoir le rappeur Américain Drake, qui pensait être entré dans une pizzeria.`,
      },
    ],
    cta: {
      url: '/mock-blog-b2b',
      label: "Voir toute l'actu de nos franchisés",
    },
  },
};
